import { useSyncExternalStore } from 'react';

/**
 * State shared between the Events breadcrumb bar (Header) and the Events
 * screens: the Archived switch and the Filters popover on the list, and the
 * open event's name and archive state on the detail page. A tiny external
 * store, so neither App nor Header needs new props for it.
 */
export interface EventsBarState {
  archived: boolean;
  category: string;
  status: string;
  /** The event open on the detail page (null on the list and the new form). */
  detail: { id: string; title: string; archived: boolean } | null;
}

const INITIAL: EventsBarState = { archived: false, category: '', status: '', detail: null };

let state: EventsBarState = INITIAL;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach(l => l());
}

export function getEventsBar(): EventsBarState {
  return state;
}

export function setEventsBar(patch: Partial<EventsBarState>): void {
  state = { ...state, ...patch };
  emit();
}

export function resetEventsBar(): void {
  state = INITIAL;
  emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function useEventsBar(): EventsBarState {
  return useSyncExternalStore(subscribe, getEventsBar, getEventsBar);
}
